import React from 'react';
import PropTypes from 'prop-types';


const ImageAttr = function ImageAttrComponent({ value }) {
  return (
    <div className="product-table__table-image-cell">
      <img
        className="product-table__img"
        alt={value.alt}
        src={value.url}
      />
    </div>
  );
};

ImageAttr.propTypes = {
  value: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.string,
  }).isRequired,
};

export default ImageAttr;
